import styled, { DefaultTheme } from 'styled-components';
import { Card, Typography } from 'antd';

declare module 'styled-components' {
  export interface DefaultTheme {
    mode?: 'light' | 'dark';
  }
}

const getThemeValue = <T,>(props: { theme?: DefaultTheme }, darkValue: T, lightValue: T): T => {
  return props.theme?.mode === 'dark' ? darkValue : lightValue;
};

export const StyledMetricCard = styled(Card)<{ isSelected?: boolean; cardColor?: string }>`
  border-radius: 12px;
  border: 1px solid ${(props) =>
    props.isSelected
      ? props.cardColor || '#2D6CCA'
      : getThemeValue(props, '#718096', '#DCDCDC')};
  background: ${(props) =>
    props.isSelected
      ? getThemeValue(props, '#2d3748', '#f7fafc')
      : getThemeValue(props, '#1a202c', '#ffffff')};
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  ${(props) =>
    props.isSelected
      ? `
    box-shadow: 0 4px 12px rgba(45, 108, 202, 0.2);
  `
      : ''}

  &:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    border-color: ${(props) => props.cardColor || '#2D6CCA'};
    background: ${(props) => getThemeValue(props, '#2d3748', '#f7fafc')};
  }

  .ant-card-body {
    padding: 20px;
  }
`;

export const MetricTitle = styled(Typography.Text)`
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => getThemeValue(props, '#a0aec0', '#718096')};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
`;

export const MetricTitleLarge = styled(Typography.Text)`
  font-size: 20px;
  font-weight: 700;
  color: ${(props) => getThemeValue(props, '#fff', '#1a202c')};
`;

export const MetricValue = styled(Typography.Title)`
  margin: 0 !important;
  font-size: 32px !important;
  font-weight: 800 !important;
  color: ${(props) => getThemeValue(props, '#fff', '#1a202c')} !important;
  line-height: 1.2 !important;

  @media (max-width: 768px) {
    font-size: 28px !important;
  }
`;

export const IconWrapper = styled.div<{ iconColor?: string }>`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => {
    const color = props.iconColor || '#2D6CCA';
    return `${color}15`;
  }};
  color: ${(props) => props.iconColor || '#2D6CCA'};
  font-size: 24px;
`;
